import { combineReducers } from 'redux';
// import { persistReducer } from "redux-persist";
// import storage from "redux-persist/lib/storage";

import userInfo from './userInfo';
import sendInfo from './sendInfo';
import authInfo from './authInfo';
import termsInfo from './termsInfo';
import sendNftInfo from './sendNftInfo';
import joinInfo from './joinInfo';
import pinInfo from './pinInfo';
import resetPwInfo from './resetPwInfo';
import outLinkInfo from './outLinkInfo';
import snsLoginInfo from './snsLoginInfo';
import totalAmtInfo from './totalAmountInfo';
import poolInfo from './poolInfo';
const rootReducer = combineReducers({
  userInfo,
  sendInfo,
  authInfo,
  termsInfo,
  sendNftInfo,
  joinInfo,
  pinInfo,
  resetPwInfo,
  outLinkInfo, // 보류(셔플이 아닌 외부 url에서 코인받기 관련 내용)
  snsLoginInfo, // 삭제예정 안씀
  totalAmtInfo,
  poolInfo,
});

export default rootReducer; // persistReducer(persistConfig, rootReducer);

export type RootState = ReturnType<typeof rootReducer>;
